/**
 * Full-page error shown when the app boots without a Shopify API key baked into
 * the bundle. This turns a silent embedded-auth failure into an obvious,
 * actionable message. Rendered by RootGate before App Bridge / Polaris load, so
 * it deliberately uses plain markup with no external dependencies.
 */
export function BuildKeyError() {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        background: '#0a0e12',
        color: '#e5e9f0',
      }}
    >
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.75rem', color: '#ff6b6b' }}>
          App misconfigured
        </h1>
        <p style={{ lineHeight: 1.6, marginBottom: '1rem' }}>
          This build is missing its Shopify API key, so the embedded app cannot
          authenticate. This almost always means the bundle was built without the{' '}
          <code>VITE_SHOPIFY_API_KEY</code> build argument.
        </p>
        <p style={{ lineHeight: 1.6, color: '#9aa5b1', fontSize: '0.9rem' }}>
          Rebuild and redeploy with <code>VITE_SHOPIFY_API_KEY</code> set (passed
          as a Docker <code>--build-arg</code>), then reload this page.
        </p>
      </div>
    </div>
  );
}
